/* eslint-disable no-restricted-imports, import/no-dynamic-require */
import { L10nModule } from 'bernie-l10n';
export var localization = function (locale) {
  var mod = new L10nModule();
  mod.current = locale;
  mod.globalize = require("lx-nimble-localization/dist/bundle-".concat(locale));
  return mod;
};